export default {"src":"/_next/static/media/Compliance.b487caa5.svg","height":1600,"width":1600};